import { render } from "./ComponenteResultadoResumen.vue?vue&type=template&id=285a9b17&scoped=true"
import script from "./ComponenteResultadoResumen.vue?vue&type=script&lang=js"
export * from "./ComponenteResultadoResumen.vue?vue&type=script&lang=js"

import "./ComponenteResultadoResumen.vue?vue&type=style&index=0&id=285a9b17&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285a9b17"]])

export default __exports__